// src/components/LegalGateModal.js
import React, { useState, useEffect } from 'react';
import styles from './HealthDashboardModal.module.css';
import { useData } from '../context/DataContext';
import ReactMarkdown from 'react-markdown';

const LegalGateModal = ({ agreement }) => {
  const { acceptLegalAgreement } = useData();
  const [content, setContent] = useState('Loading agreement...');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log('[LegalGateModal] Fetching from:', agreement.storageUrl);

    fetch(agreement.storageUrl)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.text();
      })
      .then((text) => setContent(text))
      .catch((err) => {
        // THIS WILL LOG THE REAL REASON (likely CORS)
        console.error('[LegalGateModal] Fetch Error:', err);
        setContent(
          'Error loading agreement. Please check your connection or CORS settings.',
        );
      });
  }, [agreement.storageUrl]);

  const handleAccept = async () => {
    setLoading(true);
    await acceptLegalAgreement(agreement.versionId);
    setLoading(false);
  };

  return (
    <div className={styles.modalOverlay}>
      <div
        className={styles.modalContent}
        style={{
          maxWidth: '800px',
          height: '85vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className={styles.modalHeader}>
          <h3>{agreement.displayName}</h3>
        </div>

        <div
          className={styles.rationaleCard}
          style={{
            flex: 1,
            overflowY: 'auto',
            marginBottom: '1.5rem',
            padding: '1.5rem',
          }}
        >
          {/* WRAPPER DIV HANDLES THE STYLING */}
          <div className={styles.markdownContent}>
            <ReactMarkdown>{content}</ReactMarkdown>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            alignItems: 'center',
            paddingBottom: '1rem',
          }}
        >
          <p
            style={{
              fontSize: '0.85em',
              color: '#a0a0a0',
              textAlign: 'center',
            }}
          >
            By clicking below, you acknowledge you have read and agree to the
            **Beta Test & Service Agreement** above.
          </p>
          <button
            onClick={handleAccept}
            className={styles.tierBadge}
            style={{
              backgroundColor: '#6f9aee',
              color: 'white',
              padding: '0.8rem 2.5rem',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '20px',
            }}
            disabled={loading}
          >
            {loading ? 'Processing...' : 'I Agree & Enter App'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalGateModal;
